import React, { useEffect, useState } from "react";

const Services = () => {
  const [services, setServices] = useState([]);
  useEffect(() => {
    const fetchAboutData = async () => {
      try {
        const response = await fetch(process.env.REACT_APP_BACKEND_KEY + "services");
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const responseData = await response.json();
        setServices(responseData.service); // Should work, but logging might cause issues
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchAboutData();
  }, []);

  return (
    <>
      <section
        className="service-style-one space-y-top space-y-bottom space-y-margin-top"
        id="service"
      >
        <div className="container">
          <div className="section-heading pb-5">
            <h2>MY SERVICES</h2>
          </div>
          {services.map((service, index) => (
            <div
              key={index}
              className="row gx-4 gy-3 single-service text-black wow fadeInUp"
              data-wow-delay="0.2s"
            >
              <div className="col-lg-1">
                <h5 className="service-index">{index + 1}</h5>
              </div>
              <div className="col-lg-6">
                <h3 className="service-name">
                  <a
                    href="#"
                    data-fx="1"
                    data-img="./assets/images/portfolio/feat-1.webp"
                    className="block__title"
                  >
                    {service.title}
                  </a>
                </h3>
              </div>
              <div className="col-lg-5">
                <p className="service-disc">{service.description}</p>
                <ul className="service-list">
                  {service.listText.map((heading, idx) => (
                    <li key={idx}>{heading}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default Services;
